class NotificationService {
  private permissionGranted = false;

  async requestPermission(): Promise<boolean> {
    if (!('Notification' in window)) {
      console.log('This browser does not support notifications');
      return false;
    }

    if (Notification.permission === 'granted') {
      this.permissionGranted = true;
      return true;
    }

    if (Notification.permission !== 'denied') {
      const permission = await Notification.requestPermission();
      this.permissionGranted = permission === 'granted';
      return this.permissionGranted;
    }

    return false;
  }

  showNotification(title: string, options?: NotificationOptions) {
    if (!this.permissionGranted) {
      console.log('Notification permission not granted');
      return;
    }

    const notification = new Notification(title, {
      icon: '/favicon.ico',
      badge: '/favicon.ico',
      ...options,
    });

    // Auto-close after 5 seconds
    setTimeout(() => {
      notification.close();
    }, 5000);

    // Focus window when notification is clicked
    notification.onclick = () => {
      window.focus();
      notification.close();
    };

    return notification;
  }

  showMessageNotification(senderName: string, message: string, threadId: string) {
    this.showNotification(`New message from ${senderName}`, {
      body: message.length > 100 ? message.substring(0, 100) + '...' : message,
      tag: `message-${threadId}`, // Prevents duplicate notifications
      requireInteraction: false,
    });
  }

  showTypingNotification(userName: string) {
    this.showNotification(`${userName} is typing...`, {
      body: '',
      tag: 'typing',
      requireInteraction: false,
    });
  }
}

export const notificationService = new NotificationService();
